'use client'

import { useI18n } from '@/shared/providers'

import styles from './view.module.css'

export function FeedHeader() {
    const { i18n } = useI18n()

    return (
        <h1 className={styles.feedHeaderHeading}>
            {i18n.NEWSFEED_TITLE_01}
            <br />
            {i18n.NEWSFEED_TITLE_02}
        </h1>
    )
}
